import { notify } from "@utils/helpers";
import StripePaymentModal from "./StripePaymentModal";

/**
 * Admin-side "take a deposit for this booking".
 *
 * Was an iframe pointing at a Blade page on the API. Now just wraps the shared
 * Payment Element modal. `props.onCreated(true)` on success so the calling list
 * page refreshes, `false` on cancel — unchanged, so callers keep working.
 */
const StripePay = (props) => {

  const onPaid = (data) => {
    if (data?.pending_confirmation) {
      notify("Payment", "Payment received. The booking will update shortly.", "info");
    } else {
      notify("Payment", "Deposit paid successfully");
    }
    props.onCreated(true);
  };

  return (
    <StripePaymentModal
      bookingId={ props.data.id }
      onPaid={ onPaid }
      onCancel={ () => props.onCreated(false) }
    />
  );
};

export default StripePay
